// extracted by mini-css-extract-plugin
module.exports = {"baseModal":"BaseModal_baseModal__2hQ3B","modalContainer":"BaseModal_modalContainer__3q7Os","modalHeader":"BaseModal_modalHeader__1L0sP"};